<template>
  <div class="div_1">
    <van-pull-refresh
      :animation-duration="800"
      success-text="刷新成功"
      v-model="isRefreshing"
      @refresh="onRefresh"
    >
      <div>
        <div
          style="text-align:center;padding-top:25vh;font-size:15vw;color:#EEEEEE"
          v-if="null == ticketList || ticketList.length < 1"
        >{{listEmptyText}}</div>

        <van-list
          class="ticket_list_0"
          :offset="1"
          v-model="listLoading"
          @load="listOnBottom"
          loading-text="."
          finished-text="没有更多了"
        >
          <van-cell v-for="t in ticketList"
            :key="t.orderId"
            style="padding:0;">
            <div class="left_div_1" @click.stop="showDetail(t)">
              <a
                @click.stop="showOrHideDetail(t, $event)"
                class="van-multi-ellipsis--l3"
                style="font-size:115%;"
              >{{t.orderTitle || t.orderId}}</a>

              <div style="font-size:85%;color:#8b7b8b;">
                <MobileTicketStatus v-model="t.orderStatus"/>

                <MobileTicketUser :userId="t.creatorId" />
                <span>创建</span>

                <div style="float:right;">
                  <span>{{t.createdAt|ticketTime}}</span>
                </div>

                <template v-if="!!t.ticketEventList && t.ticketEventList.length > 0">
                  <div class="ticketEvent_1" v-for="e in t.ticketEventList" :key="e.flowId">
                    <MobileTicketUser :userId="e.dealUserId" />
                    <span>{{e.operateContent}}</span>
                    <span v-if="e.assignUserId">
                      给
                      <MobileTicketUser :userId="e.assignUserId" />
                    </span>

                    <span>{{e.createdAt|ticketTime}}</span>

                    <span
                      class="plain-text-remark"
                      style="color:#000"
                      v-if="e.orderRemark"
                      v-text="'：' + e.orderRemark.remarkContent"
                    ></span>
                  </div>
                </template>
              </div>
            </div>

            <div class="right_btn_3" @click="goDetail(t)">
              <div class="right_btn_4">详情</div>
            </div>
          </van-cell>
        </van-list>
      </div>

    </van-pull-refresh>
  </div>
</template>

<script>
import AppNative from "@/assets/utils/AppNative";

export default {
  name: "MobileTicketList",

  props : ['list'],

  watch : {
    list() {
      this.ticketList = this.list;
    }
  },

  mounted() {
    this.ticketList = this.list;
  },

  data() {
    return {
      ticketList : [],
      listEmptyText : "",
      hasMore: true,
      isRefreshing: false,
      listLoading: false
    };
  },

  methods: {
    setListLoading( v ) {
      this.listLoading = v;
    },

    setRefreshing( v ) {
      this.isRefreshing = v;
    },

    setHasMore(v) {
      this.hasMore = v;
    },

    listOnBottom() {
      if ( !this.hasMore ) {
        this.listLoading = false;
        return;
      }

      // console.log('#109 before listOnBottom', this);

      this.listLoading = true;
      this.$emit('bottom');

      // console.log('#111 after emit bottom');
    },

    onRefresh() {
      this.isRefreshing = true;

      this.$emit('refresh', 1);
    },

    showOrHideDetail(t) {
      if (!!t.ticketEventList && t.ticketEventList.length > 0) {
        t.ticketEventList = [];

        this.$forceUpdate(); // 强制刷新
        return; // 如果已展示，再点一次，就收起来
      }

      this.showDetail(t);
    },

    showDetail(t) {
      // 其他的全收起来
      for (var i = 0; i < this.ticketList.length; i++) {
        this.ticketList[i].ticketEventList = [];
      }

      // 加载本工单的回复数据
      var _this = this;
      sdk.TicketEventApi().listByTicketNo({
          ticketNo: t.orderId,
          page : { orderBy : '`flow_id` DESC' }
        }).then(res => {
          t.ticketEventList = res.list;

          _this.$forceUpdate(); // 强制刷新
        });
    },

    goDetail(t) {
      this.$router.push({ path: "/ticket-vue/d", query: { no: t.orderId } });
    }
  }
};
</script>

<style scoped>
.ticket_list_0 {
  min-height : calc(100vh - 45px)
}

.div_1 {
  padding-top:45px;
}

.ticketEvent_1 {
  border: 0 solid #f8f3f3;
  border-top-width: 1px;
}

.plain-text-remark {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.left_div_1 {
  margin: 5px -10px 5px 10px;
  width: 85%;
  display: inline-block;
  padding-right: 20px;
}

.right_btn_3 {
  position: absolute;
  display: inline-block;
  width: 15%;
  height: 100%;
  text-align: center;
  border-radius: 5px;
}

.right_btn_4 {
  cursor: pointer;
  border: 1px solid #f4f3f2;
  background: #FCFCFC;
  height: 100%;
  color: #79878e;
  font-size: 110%;
}

.right_btn_4:before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.van-cell:not(:last-child)::after {
    left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketList.vue